import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["to", "exact"];
import NativeUIIconButton from 'UIComponents/button/UIIconButton';
import AbstractRouterLink from './internal/AbstractRouterLink';
import useIsActive from './internal/useIsActive';
import { jsx as _jsx } from "react/jsx-runtime";
// Unearthing a hidden prop
const UIIconButton = NativeUIIconButton;

/**
 * A [`UIIconButton`](https://private.hubteamqa.com/uicomponents-storybook/?path=/docs/uicomponents-button-uiiconbutton--basic)
 * type component with router support.
 */
export default function UIRouterIconButton(props) {
  const {
      to,
      exact = false
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const active = useIsActive(to, exact);
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, rest, {
    to: to,
    active: active,
    component: UIIconButton
  }));
}
const _AbstractRouterLink$p = AbstractRouterLink.propTypes,
  sanitizedAbstractRouterLinkPropTypes = _objectWithoutPropertiesLoose(_AbstractRouterLink$p, ["component"]);
UIRouterIconButton.propTypes = Object.assign({}, sanitizedAbstractRouterLinkPropTypes, UIIconButton.propTypes);
UIRouterIconButton.defaultProps = Object.assign({}, UIIconButton.defaultProps, {
  use: 'tertiary-light'
});